module.exports = __webpack_public_path__ + "static/media/asignatura2.8701f999.png";